import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function RequireAuth({ children, requirePremium = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="require-auth-loading" className="min-h-[60vh] grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-zinc-700" />
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (requirePremium && !user.is_premium) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/pricing?upgrade=1&next=${next}`} replace />;
  }

  return children;
}
